import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AmericanState } from "src/app/enums/american-state";
import { ModalName } from "src/app/enums/modal-name";
import { IClientProfileInfo } from "src/app/models/client/client-info";
import { IUpdateClientInfoPayload } from "src/app/models/client/update-client-info-payload";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-edit-client-info-modal",
  templateUrl: "./edit-client-info-modal.component.html",
  styleUrls: ["./edit-client-info-modal.component.scss"],
})
export class EditClientInfoModalComponent implements OnChanges {
  @Input() clientProfileInfo: Partial<IClientProfileInfo> | null = null;

  @Output() submit = new EventEmitter<IUpdateClientInfoPayload>();

  private readonly _phoneNumberPattern = "[0-9+()-]{1,}";

  form = new UntypedFormGroup({
    firstName: new UntypedFormControl("", Validators.required),
    lastName: new UntypedFormControl("", Validators.required),
    billingEmail: new UntypedFormControl("", [Validators.required, Validators.email]),
    phoneNumber: new UntypedFormControl("", [
      Validators.required,
      Validators.pattern(this._phoneNumberPattern),
    ]),
    companyName: new UntypedFormControl("", [Validators.required, Validators.minLength(2)]),
    address: new UntypedFormControl(""),
    mailStop: new UntypedFormControl(""),
    city: new UntypedFormControl(""),
    zipCode: new UntypedFormControl(""),
    state: new UntypedFormControl(AmericanState.Florida),
  });

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.EditClientInfo;
  }

  get states() {
    return Object.values(AmericanState);
  }

  ngOnChanges() {
    this.patchFormWithClientProfileInfo();
  }

  onClose() {
    this._modalService.closeModal();
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }

    const { firstName, lastName, billingEmail, phoneNumber, companyName, address, mailStop, city, zipCode, state } =
      this.form.value;

    const payload: IUpdateClientInfoPayload = {
      firstName,
      lastName,
      billingEmail,
      phoneNumber,
      companyName,
      address: mailStop ? `${address}, ${mailStop}` : address,
      city,
      zipCode,
      state,
      timeZone: this.clientProfileInfo?.timeZone,
    };

    this.submit.emit(payload);
    this._modalService.closeModal();
  }

  private patchFormWithClientProfileInfo() {
    const {
      firstName = "",
      lastName = "",
      billingEmail = "",
      phoneNumber = "",
      companyName = "",
      address = "",
      city = "",
      zipCode = "",
      state = AmericanState.Florida,
    } = this.clientProfileInfo ?? {};

    this.form.patchValue({
      firstName,
      lastName,
      billingEmail,
      phoneNumber,
      companyName,
      address,
      city,
      zipCode,
      state,
    });
  }
}
